import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const ConsultFormSlice = createSlice({
  name: "ConsultFormReducer",
  initialState,
  reducers: {
    setConsulltData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setConsulltData, resetState } = ConsultFormSlice.actions;

export default ConsultFormSlice.reducer;
